import { Timer } from 'browser/components/atomic-elements/atoms/timer/timer'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
export const TimerField = LabelFieldFactory({ InputComponent: Timer })
